/**
 *
 * PrivateRoute
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Route } from 'react-router-dom';
import { REACT_APP_SIGN_OUT_REDIRECT_URL } from 'runtimeEnvVars';

const LoginRedirectComponent = () => {
  window.location.href = REACT_APP_SIGN_OUT_REDIRECT_URL;
  return null;
};

function PrivateRoute({
  component: Component,
  isLoggedIn,
  authUrl,
  location,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? <Component {...props} /> : <LoginRedirectComponent />
      }
    />
  );
}

PrivateRoute.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
  authUrl: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default memo(PrivateRoute);
